const ReportFormFields={
    projectId: "projectId",
    projectName: "projectName",
    configurationName: "configurationName",
    revisionHistory: "revisionHistory",
    contactName: "contactName",
    email: "email"    
}
export default ReportFormFields